import React, { useState, useEffect, useCallback, useContext, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Input } from 'reactstrap';
import { MENUITEMS } from '../SideBar-Layout/Menu';
import ListOfMenu from './Bookmark/ListOfMenu';
import EmpltyClass from './Bookmark/EmptyClass';
import CustomContext from '../../_helper/customizer';
import { Search } from 'react-feather';
import { SearchIconss } from '../../Data/svgIcons';

const Searchbar = () => {
    const location = useLocation();
    const mainmenu = MENUITEMS;
    const [searchValue, setSearchValue] = useState('');
    const [searchIcon, setSearchIcon] = useState(false);
    const [searchToggle, setSearchToggle] = useState(false);
    const [searchResult, setSearchResult] = useState(false);
    const { setIsClose } = useContext(CustomContext);
    const [IsOpen, setIsOpen] = useState(false);
    const OnhandelClick = () => setIsOpen(!IsOpen);
    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            setSearchValue('');
            setSearchResult([]);
            setIsClose(false);
        }
    }, []);
    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction]);

    // Reset search input when the route changes
    useEffect(() => {
        setSearchValue('');
        setSearchToggle(false);
        setSearchResult([]);
    }, [location.pathname]); // Runs every time the path changes

    const checkSearchResultEmpty = (items) => {
        setSearchIcon(items.length === 0);
    };
    const addFix = () => setSearchToggle(true);
    const removeFix = () => {
        setSearchValue('');
        setSearchToggle(false);
    };
    const handleSearchKeyword = (keyword) => {
        keyword ? addFix() : removeFix();
        const items = [];
        setSearchValue(keyword);
        mainmenu.map(menuItems => {
            menuItems.Items.forEach(mItems => {
                if (mItems.title.toLowerCase().includes(keyword) && mItems.type === 'link') {
                    items.push(mItems);
                }
                if (mItems.children) {
                    mItems.children.forEach(subItems => {
                        if (subItems.title.toLowerCase().includes(keyword) && subItems.type === 'link') {
                            subItems.icon = mItems.icon;
                            items.push(subItems);
                        }
                        if (subItems.children) {
                            subItems.children.forEach(suSubItems => {
                                if (suSubItems.title.toLowerCase().includes(keyword)) {
                                    suSubItems.icon = mItems.icon;
                                    items.push(suSubItems);
                                }
                            });
                        }
                    });
                }
            });
            return menuItems;
        });
        checkSearchResultEmpty(items);
        setSearchResult(items);
    };

    return (
        <Fragment>
            <Col className="left-side-header ps-0 d-md-block dash-10">
                <div className="w-100 searchbar">
                    <div className="resp-serch-box d-md-none resp-serch-input">
                        <Search onClick={() => OnhandelClick(!IsOpen)} />
                    </div>
                    <div className={`input-group form-group search-form ${IsOpen ? 'open' : ''}`}>
                        <span className='input-group-text'><SearchIconss /></span>
                        <Input type="text" placeholder="Search here.." value={searchValue} onChange={(e) => handleSearchKeyword(e.target.value)} />
                        <ListOfMenu searchValue={searchValue} searchResult={searchResult} removeFix={removeFix} searchBar={true} searchToggle={searchToggle} />
                        <EmpltyClass searchIcon={searchIcon} search={true} />
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default Searchbar;